import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const env = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCsb1qczjbyMF0ANi_cGE6kAUODPQYwxxE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "portofoliocoment-8333d.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "portofoliocoment-8333d",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "portofoliocoment-8333d.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "211237102672",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:211237102672:web:74440bd8571af22a901d55",
};

// Basic validation to help diagnose misconfigured env
const missing = Object.entries(env)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (missing.length > 0) {
  // This will show up once in console to help debugging
  // Do not throw to avoid crashing import sites during SSR or tests
  console.error("Firebase env vars missing:", missing);
}

const firebaseConfig = env as {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export default app;

